<footer class="footer">

    <div class="footer-main">

        <div class="container">

            <div class="row">

                <!-- About -->
                <div class="col-sm-6 col-md-3">

                    <div class="widget widget-links">

                        <h5 class="widget-title">About Us</h5>

                        <div class="footer-about">

                            <p>{{aboutText}}</p>

                            <ul class="social-media">

                                <li *ngFor="let social of socialLinks">
                                    <a [href]="social.link" class="bi {{social.icon}}"></a>
                                </li>

                            </ul>

                        </div>

                    </div>

                </div>


                <!-- Quick Links -->
                <div class="col-sm-6 col-md-2">

                    <div class="widget widget-links">

                        <h5 class="widget-title">Quick Links</h5>

                        <ul>

                            <li>
                                <a routerLink="/about-us">About Us</a>
                            </li>
                            <li>
                                <a routerLink="/services">Services</a>
                            </li>
                            <li>
                                <a routerLink="/portfolio-one">Portfolio</a>
                            </li>
                            <li>
                                <a routerLink="/blog-grid">Blogs</a>
                            </li>
                            <li>
                                <a routerLink="/contact">Contact Us</a>
                            </li>

                        </ul>

                    </div>

                </div>


                <!-- Recent Posts -->
                <div class="col-sm-6 col-md-4">

                    <div class="widget widget-links">

                        <h5 class="widget-title">Recent Post</h5>

                        <div class="row post-sm-content" *ngFor="let post of recentPosts">

                            <div class="col-md-3 col-sm-3 col-xs-3">

                                <img class="img-overlay border-radius-100" [src]="post.image" [alt]="post.title">

                            </div>

                            <div class="col-md-9 col-sm-9 col-xs-9">

                                <h6>{{post.title}}</h6>

                                <p>{{post.desc}}</p>

                            </div>

                        </div>

                    </div>

                </div>


                <!-- Contact -->
                <div class="col-sm-6 col-md-3">

                    <div class="widget widget-text">

                        <h5 class="widget-title">Contact Us</h5>

                        <ul class="footer-contact">

                            <li *ngFor="let contact of contactInfo">

                                <i class="bi {{contact.icon}}"></i>

                                <p>{{contact.text}}</p>

                            </li>

                        </ul>

                    </div>

                </div>


            </div>

        </div>

    </div>


    <!-- Copyright -->
    <div class="footer-copyright">

        <div class="container">

            <div class="row d-flex justify-content-center">

                <div class="col-md-2">

                    <div class="logo-footer">

                        <a href="index.html">

                            <img class="img-responsive" src="assets/images/logo-footer.png" alt="footer-logo">

                        </a>

                    </div>

                </div>

            </div>

            <div class="row">

                <div class="col-md-12">

                    <div class="copy-right">

                        © Copyright 2026 Chaos. Designed By
                        <a href="https://themeforest.net/user/designsninja/portfolio" target="_blank">DesignsNinja</a>

                    </div>

                </div>

            </div>

        </div>

    </div>

</footer>